<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
import { useI18n } from 'vue-i18n';
import AppLogoIcon from '@/components/AppLogoIcon.vue';
import { home } from '@/routes';

const { t } = useI18n();

defineProps<{
    panelEyebrow?: string;
    panelHeadline?: string;
    panelSub?: string;
}>();
</script>

<template>
    <div class="flex min-h-dvh w-full bg-background font-geist text-foreground">
        <!-- Content column -->
        <div class="flex min-w-0 flex-1 flex-col px-8 py-8 sm:px-14">
            <Link :href="home()" class="inline-flex items-center gap-2 no-underline">
                <AppLogoIcon class="h-[22px] w-[18px] shrink-0 text-foreground" />
                <span class="text-[15px] font-semibold tracking-tight text-foreground">Novantt</span>
            </Link>

            <div class="mx-auto flex w-full max-w-xl flex-1 flex-col justify-center">
                <slot />
            </div>

            <div class="flex gap-4 text-[11px] text-muted-foreground">
                <span>&copy; Novantt {{ new Date().getFullYear() }}</span>
                <a href="/terms" class="text-muted-foreground no-underline hover:text-foreground">{{ t('auth.footer.terms') }}</a>
                <a href="/privacy" class="text-muted-foreground no-underline hover:text-foreground">{{ t('auth.footer.privacy') }}</a>
            </div>
        </div>

        <!-- Brand panel -->
        <div class="relative hidden w-[520px] shrink-0 flex-col overflow-hidden p-10 text-white lg:flex">
            <img src="/images/novantt-auth-bg.webp" alt="" class="pointer-events-none absolute inset-0 h-full w-full object-cover" />
            <div class="pointer-events-none absolute inset-0 bg-black/75"></div>

            <div class="relative mt-auto">
                <div v-if="panelEyebrow" class="text-[11px] font-medium uppercase tracking-wider text-white/55">{{ panelEyebrow }}</div>
                <div v-if="panelHeadline" class="mt-1 text-[28px] font-semibold leading-snug tracking-tight lg:text-[32px]">{{ panelHeadline }}</div>
                <div v-if="panelSub" class="mt-3.5 text-[13px] leading-relaxed text-white/65">{{ panelSub }}</div>
            </div>
        </div>
    </div>
</template>
